import React, { SVGProps } from 'react';

export const AiWriter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="currentColor"
        d="M7.229.797 5.836 4.415c-.21.548-.269.682-.344.788a1.283 1.283 0 0 1-.285.287l-.004.002c-.106.077-.24.135-.788.345L.797 7.229V8.81l3.618 1.392c.548.212.682.268.788.343.113.081.21.178.29.29.074.105.132.24.342.787l1.394 3.619H8.81l1.39-3.619c.212-.547.269-.682.345-.787.082-.113.177-.208.286-.287l.004-.003c.105-.075.24-.133.787-.343l3.619-1.392V7.23l-3.619-1.392c-.547-.21-.682-.268-.787-.345a1.283 1.283 0 0 1-.287-.285l-.003-.004c-.075-.106-.134-.24-.344-.788L8.81.797H7.228Zm1.39 4.227c.18.466.317.84.545 1.16.19.267.424.501.69.69.32.228.694.365 1.16.544l1.564.6-1.564.603c-.466.18-.84.316-1.16.545-.269.192-.496.42-.684.679l-.006.008c-.228.32-.365.695-.544 1.16l-.6 1.564-.603-1.563c-.18-.466-.317-.84-.544-1.16a2.99 2.99 0 0 0-.68-.682l-.009-.006c-.32-.229-.693-.366-1.16-.545l-1.562-.603 1.562-.6c.466-.18.84-.316 1.16-.543.267-.19.5-.424.69-.69.226-.321.363-.694.543-1.161L8.02 3.46l.6 1.563Zm11.093 5.395a3 3 0 0 0-1.939.71l-6.46 5.675a3.007 3.007 0 0 0-.756 1.226l-.006.021v.002l-1.62 5.191 5.392-.724a3.01 3.01 0 0 0 1.536-.685l-.085-.113.094.106 6.306-5.534a2.96 2.96 0 0 0 1.031-2.008v-.01l.002-.01v-.018a2.953 2.953 0 0 0-.704-2.171l.004.004-.504-.598L22 11.48a3.003 3.003 0 0 0-2.29-1.059l.002-.002Zm-.002 1.696c.396 0 .753.174.998.46h-.001l.508.603v.003c.19.218.306.503.31.815l-.006.13-.002.012-.017.127a1.273 1.273 0 0 1-.432.747l-.002.001-.01.008-6.3 5.53c-.18.154-.408.259-.658.29l-.006.002-2.753.37.827-2.652a1.32 1.32 0 0 1 .398-.604l.001-.001.01-.01 6.298-5.527c.224-.19.517-.305.836-.305h.001v.001ZM1.384 21.149v1.694h4.518v-1.694H1.384Zm-.001-3.764v1.693h6.402v-1.694l-6.402.001Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
